module.exports = __webpack_public_path__ + "img/dashboard.b7574622.png";